import { ModelBase, ModelState } from '../../core/model/model-base';
import { LocalDate } from '../../core/model/local-date';
import { Money } from '../../core/model/money';

export class RentPeriod extends ModelBase {
  constructor() {
    super();

    Object.defineProperties(this, {
      _fromDate: { writable: true, enumerable: false },
      _toDate: { writable: true, enumerable: false },
      _dueDate: { writable: true, enumerable: false },
    });
  }

  private _dueDate: LocalDate;
  private _fromDate: LocalDate;
  private _toDate: LocalDate;

  get dueDate(): LocalDate {
    return this._dueDate;
  }
  set dueDate(value: LocalDate) {
    this._dueDate = LocalDate.fromDate(value);
  }
  get fromDate(): LocalDate {
    return this._fromDate;
  }
  set fromDate(value: LocalDate) {
    this._fromDate = LocalDate.fromDate(value);
  }
  get toDate(): LocalDate {
    return this._toDate;
  }
  set toDate(value: LocalDate) {
    this._toDate = LocalDate.fromDate(value);
  }

  invoiceId: string;
  invoiceNumber: string;
  periodText: string;
  invoiceTotalAmount: Money;
}
